import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Help } from '@mui/icons-material';

const ToolTip = ({ toolTip, position = 'top-start' }) => {
  const [open, setOpen] = useState(null);
  if (toolTip) {
    return (
      <Tooltip title={toolTip} placement={position} enterTouchDelay={0} // Show tooltip immediately on touch
      leaveTouchDelay={3000} // Keep it open longer
      componentsProps={{
        tooltip: {
          sx: {fontSize: 14, fontFamily: ["Helvetica Neue", "Arial", "Helvetica", "sans-serif"], maxWidth: 'none'}
        },
      }}>
        <IconButton className="tooltip">
          <Help className="btn-point-events" />
        </IconButton>
      </Tooltip>
    );
  }
  return null;
};

const returnTag = (
  className = '',
  position = 'top-start',
  tag = '',
  text,
  toolTip,
) => {
  const newTag = tag.toUpperCase();
  switch (newTag) {
    case 'H1':
      return (
        <h1 className={`help-text ${className}`}>
          {text}
          <ToolTip toolTip={toolTip} position={position} />
        </h1>
      );
    case 'H2':
      return (
        <h2 className={`help-text ${className}`}>
          {text}
          <ToolTip toolTip={toolTip} position={position} />
        </h2>
      );
    case 'H3':
      return (
        <h3 className={`help-text ${className}`}>
          {text}
          <ToolTip toolTip={toolTip} position={position} />
        </h3>
      );
    default:
      return (
        <p className={`help-text ${className}`}>
          {text}
          <ToolTip toolTip={toolTip} position={position} />
        </p>
      );
  }
};

export default function({
  className,
  position = 'top-start',
  tag,
  text,
  toolTip,
}) {
  return returnTag(className, position, tag, text, toolTip);
}
